import type { MediaMetric } from './aggregate';

const BILLION = 1_000_000_000;
const MILLION = 1_000_000;
const THOUSAND = 1_000;

function scale(value: number): string {
  const magnitude = Math.abs(value);
  if (magnitude >= BILLION) return `${(value / BILLION).toFixed(1)}B`;
  if (magnitude >= MILLION) return `${(value / MILLION).toFixed(1)}M`;
  if (magnitude >= THOUSAND) return `${(value / THOUSAND).toFixed(1)}K`;
  return value.toFixed(0);
}

export const formatSpend = (value: number): string => `$${scale(value)}`;

export const formatImpressions = (value: number): string => scale(value);

export const formatCpm = (value: number): string =>
  `$${value >= 10 ? value.toFixed(0) : value.toFixed(1)}`;

export const formatSharePercent = (value: number): string => `${value.toFixed(1)}%`;

/**
 * Whole percents read cleanly at the sizes these charts deal in, but rounding a 0.4% swing to
 * "0%" states the opposite of what happened, so anything under a point keeps a decimal.
 */
const percentDigits = (value: number): number => (value !== 0 && Math.abs(value) < 1 ? 1 : 0);

export const formatSignedPercent = (value: number): string =>
  `${value > 0 ? '+' : ''}${value.toFixed(percentDigits(value))}%`;

export const formatPercentMagnitude = (value: number): string => {
  const magnitude = Math.abs(value);
  return `${magnitude.toFixed(percentDigits(magnitude))}%`;
};

export function formatMetricValue(value: number, metric: MediaMetric): string {
  if (metric === 'spend') return formatSpend(value);
  if (metric === 'impressions') return formatImpressions(value);
  return formatCpm(value);
}
